<template>
    <div>
        <v-card v-show="!showItemPicker && !showPricePicker">
            <v-toolbar color="info" height="40" >
                <v-toolbar-title>
                    {{title}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.prevent="closeItemEdit()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <!-- <v-alert
                    :value="true"
                    type="info"
                    >
                    This item has promotion of 20% discount for Unit: CS-30. Min. Qty: 1, Max. Qty: 10.

                </v-alert> -->
                <v-alert v-show="itemData.promotions"
                    v-for="promotion in itemAllActivePromotions"
                    :key="promotion.id"
                    :value="true"
                    type="info"
                    >
                    <div class="d-flex justify-space-between align-center">
                        <div>{{ getPromotionMessage(promotion) }}</div>
                       
                        <v-btn
                            v-show="!itemData.promotionApplied || promotion.id !== itemData.promotionApplied.id"
                            color="primary"
                            small
                            @click="applyPromotion(promotion)"
                            >
                            Apply
                            </v-btn>
                            <v-chip
                            v-show="itemData.promotionApplied &&  promotion.id === itemData.promotionApplied.id"
                            color="success"
                            small
                            label
                            >
                            Applied
                            </v-chip>
                    </div>
                </v-alert>
                <v-form ref="quoteItemform" v-model="itemFormValid" lazy-validation>
                    <v-layout>
                        <v-flex xs12>
                            <v-checkbox
                                v-model="isCustomItem"
                                label="This is a custom item, I will enter data manually"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.catalogNum" 
                                label="Catalog #"
                                :readonly="!isCustomItem"
                                type="text"
                                >
                                    <!-- <v-menu
                                    slot="append-outer"
                                    style="top: -12px"
                                    offset-y
                                    v-show="!isCustomItem "
                                    >
                                        <v-btn slot="activator" color="primary" @click="showItemPicker=true">
                                            Pick Item
                                        </v-btn>
                                    </v-menu> -->
                                </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.description" 
                                label="Desc."
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.qty" 
                                type="number"
                                label="Qty."
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs8 pl-1>
                            <v-text-field 
                                v-model="itemData.discountPct" 
                                type="number"
                                label="Discount %"
                                :disabled="discountEditDisabled"
                                :hint="discountHint"
                                persistent-hint
                                ></v-text-field>
                        </v-flex>
                        <!-- <v-flex xs5>
                            <v-text-field 
                                v-model="itemData.DiscountUnitAmt" 
                                type="number"
                                label="Discount $ Per Unit"
                                ></v-text-field>
                        </v-flex> -->
    
                        <v-flex xs3>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.unit" 
                                label="Unit"
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs3 pl-1>
                            <v-select 
                                :rules="[rules.required]"
                                v-model="itemData.currnIdx"
                                :items="currencyTypes" 
                                item-text="name" 
                                item-value="id" 
                                label="Currency"
                                ></v-select>
                        </v-flex>
                        <v-flex xs3 pl-1>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.unitPrice" 
                                type="number"
                                label="Unit Price"
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs3 v-show="allowPickPrice">
                            <v-btn slot="activator" color="primary" @click="showPricePicker=true">
                                <!-- <v-icon left>menu</v-icon> -->
                                Pick Price
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field 
                                v-model="itemData.notes" 
                                label="Internal Notes"
                                ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs-12 pt-3 class="text-xs-center">
                            <v-btn :disabled="!itemFormValid" @click="onSaveItem(itemData)">Save</v-btn>
                            <!-- <v-btn @click="clear">clear</v-btn> -->
                        </v-flex>
                    </v-layout>
                    <!-- {{ itemData }} -->
    
                </v-form>
            </v-card-text>

        </v-card>
        <ctlItemSearch @onItemPicked="onItemPicked" v-show="showItemPicker"></ctlItemSearch>
        <ctlItemPriceSearch @onItemPricePicked="onItemPricePicked" 
            :itemId="itemData.itemId"
            :facilityPriceLevel="facilityPriceLevel"
            :qty="itemData.qty"
            v-show="showPricePicker"></ctlItemPriceSearch>
    </div>
</template>
<script>
import ctlItemSearch from '@/components/ctlItemSearch'
import ctlItemPriceSearch from '@/components/ctlItemPriceSearch'
import { mapGetters, mapActions } from "vuex";

export default {
    props: ['originalItemData', 'facilityPriceLevel', 'hidePickPriceButton'],
    components: {
        ctlItemSearch,
        ctlItemPriceSearch,
    },
    data () {
        return {
            isCustomItem: false,
            itemData: {},
            showItemPicker: false,
            showPricePicker: false,
            itemFormValid: false,
            itemAllActivePromotions: [],
            currencyTypes: [
                {id: 1008, name: 'Dollar'},
                {id: 1009, name: 'Euro'},
            ],
            rules: {
                required: v => !!v || "This field is required"
            },
        }
    },
    computed: {
        isNew () {
            return !this.originalItemData
        },
        title () {
            return this.isNew? 'Add Item' : 'Edit Item'
        },
        discountHint () {
            return this.itemData.discountPct >= 5 ? 'For discounts over 5%, the quote must be approved' : 
                this.discountEditDisabled? 'Only permitted for items with List Price Level or Promotional status' : ''
        },
        allowPickPrice () {
            // Hide Pick Price button when using GShape API mode (hidePickPriceButton=true)
            // or when item has no itemId (custom item)
            return this.itemData.itemId && !this.hidePickPriceButton
        },
        // itemData () {
        // },
        // isCustomItem () {
        //     if (this.isNew) {
        //         return false
        //     } else {
        //         // if it has itemId, it is an HealthMark inventory item
        //         return !!this.originalItemData.itemId
        //     }
        // },
        discountEditDisabled() {
            if (!this.itemData){
                return true
            }
            //20240815, allow discount for promotion items
            // if (this.itemData.itemNumber == '6036002501' 
            //     && new Date() < new Date('2024-11-01')
            // ) {
            //     console.log('promotion item: 6036002501')
            //     return false
            // }
            if (this.itemData.unitPricePriceLevel == 'LIST') {
                // console.log('this.itemData.unitPricePriceLevel', this.itemData.unitPricePriceLevel)
                return false
            }
            if (this.itemData.promotions) {
                // console.log('promotions', this.itemData.promotions)
                return true
            }
            return true
        }
    },
    methods: {
        ...mapActions('pubQuoteEdit', [
            'saveQuoteItem',
            'applyPromotionToQuoteItem'
        ]),

        onItemPicked (itemDataPicked) {
            this.showItemPicker = false
            if(itemDataPicked) {
                this.itemData = Object.assign({}, this.itemData, itemDataPicked)
            }
        },
        onItemPricePicked (itemPriceDataPicked) {
            this.showPricePicker = false
            if(itemPriceDataPicked) {
                var mergeData = {
                    unit: itemPriceDataPicked.uofm,
                    unitPrice: itemPriceDataPicked.uofmPrice,
                    itemPriceId: itemPriceDataPicked.itemPriceId
                }
                this.itemData = Object.assign({}, this.itemData, mergeData)
            }
        },
        closeItemEdit () {
            this.$emit('onSaveItem', null)
        },
        // if itemDataToSave == null,it means we will close this popup
        async onSaveItem (itemDataToSave) {
            // console.log('onItemPicked called')
            // console.table(itemDataToSave)
            if (this.$refs.quoteItemform.validate()) {

                var result = await this.saveQuoteItem(itemDataToSave);
                
                this.$emit('onSaveItem', itemDataToSave)
                //reset data for reuse next time
                this.itemData = {}
            }
        },
        getPromotionMessage(promotion) {
            const maxQty = promotion.maxQty > 0 ? promotion.maxQty : "unlimited";
            if (promotion.promotionType === "BuyXGetYFree") {
                return `This item ${promotion.itemNumber} has Buy ${promotion.buyXGetYFreeBuyQty} Get ${promotion.buyXGetYFreeGetQty} Free promotion. Min. Qty: ${promotion.minQty}, Max. Qty: ${maxQty}, Unit: ${promotion.uom?promotion.uom : 'any'}.`;
            }
            else if (promotion.promotionType === "DiscountPct") {
                return `This item ${promotion.itemNumber} has ${promotion.promotionAmt}% of promotion discount. Min. Qty: ${promotion.minQty}, Max. Qty: ${maxQty}, Unit: ${promotion.uom?promotion.uom : 'any'}.`;
            } else {
                const discountPercentage = this.calculateDiscountPercentage(promotion.promotionAmt);
                return `This item ${promotion.itemNumber} has a promotion unit price of $${promotion.promotionAmt}. Min. Qty: ${promotion.minQty}, Max. Qty: ${maxQty}, Unit: ${promotion.uom?promotion.uom : 'any'}.`;
            }
        },
        calculateDiscountPercentage(promotionPrice) {
            const discount = this.unitPrice - promotionPrice;
            const percentage = (discount / this.unitPrice) * 100;
            return percentage.toFixed(2);
        },
        async applyPromotion(promotion) {
            // Here you would implement the logic to apply the promotion to the quote item
            console.log(`Applying promotion ${promotion.id} to quote item`);
            if (promotion.promotionType === "DiscountPct") {
                console.log(`Discount of ${promotion.promotionAmt}% applied`);
            } else {
                const discountPercentage = this.calculateDiscountPercentage(promotion.promotionAmt);
                console.log(`New price: $${promotion.promotionAmt} (${discountPercentage}% off)`);
            }
            //check unit
            if (promotion.uom && this.itemData.unit 
                && promotion.uom.toUpperCase() != this.itemData.unit.toUpperCase()) {
                    alert(`Cannot apply promotion to item. The Promotion Unit ${promotion.uom} does not match the Item Unit ${this.itemData.unit}.`)
                    return
            }
            if (promotion.minQty && this.itemData.qty 
                && promotion.minQty > this.itemData.qty) {
                    alert(`Cannot apply promotion to item. The Promotion Min. Qty ${promotion.minQty} is greater than the Item Quoted Qty ${this.itemData.qty}.`)
                    return
            }
            if (promotion.maxQty && this.itemData.qty 
                && promotion.maxQty < this.itemData.qty) {
                    alert(`Cannot apply promotion to item. The Promotion Max. Qty ${promotion.maxQty} is less than the Item Quoted Qty ${this.itemData.qty}.`)
                    return
            }
            if (this.$refs.quoteItemform.validate()) {
                this.itemData.promotionApplied = promotion

                await this.applyPromotionToQuoteItem(this.itemData)
                // emit an event here to notify the parent component
                this.$emit('onSaveItem', this.itemData);
            }
        }
    },
    watch: {
        originalItemData (value) {
            if (this.isNew) {
                this.itemData = {}
                this.isCustomItem = false
                this.itemAllActivePromotions = []
            } else {
                this.itemData = Object.assign({}, this.originalItemData)
                // if it has itemId, it is an HealthMark inventory item
                this.isCustomItem = !this.originalItemData.itemId
                if (!this.isCustomItem && this.originalItemData.promotions) {
                    this.itemAllActivePromotions = this.originalItemData.promotions
                }

            }

        }
    },
    created() {

    }
}
</script>
